export const isString = (arg: unknown): arg is string => typeof arg === 'string'
